import {guestRequest} from './guestApi';
import {getAuthToken} from './auth';
import {workspaceAccount,normalizeWorkspaceAccount} from './db';

type Activity = {kind:'gps.changed';enabled:boolean}|{kind:'sidebar.clicked';path:string}|{kind:'place.opened';placeId:string};
/** Best-effort interaction history. Never block navigation, prompt for location,
 * or replay an old account's activity after sign-in/offline recovery. */
export function recordActivity(event:Activity,account:string|undefined):void {
 if(!account||normalizeWorkspaceAccount(account)!==workspaceAccount||!getAuthToken()||!navigator.onLine)return;
 void guestRequest('/guest/activity-events','POST',event).catch(()=>{});
}
export interface AccountActivity {activity_id:string;kind:string;details:Record<string,unknown>;actor_email:string;created_at:string}
export interface AccountHistory {events:AccountActivity[];nextBefore:string|null;page:number;total:number;totalPages:number;pageSize:number;snapshot:string;historyLimit:number}
export function activityLabel(event:AccountActivity):string {
 const d=event.details;
 switch(event.kind){
  case 'invitation.email_accepted':return 'Invitation accepted by Gmail for sending';
  case 'invitation.email_failed':return 'Invitation was not sent';
  case 'invitation.email_unknown':return 'Invitation send outcome unconfirmed';
  case 'users.config_changed':return 'User history limit changed — '+String(d.history_limit)+' actions per user';
  case 'notifications.dispatched':return 'Notification dispatched — '+(({admin:'Admin message',visits:'Visit',community:'Nature Gallery',patches:'Patch',patch_revealed:'New patch revealed',photo_big_buck:'Big buck photo',test:'Test'} as Record<string,string>)[String(d.topic)]||'Notification');
  case 'notifications.big_buck_config_changed':return 'Big buck alerts '+(d.enabled?'enabled':'disabled');
  case 'notifications.patch_reveal_config_changed':return 'New patch reveal alerts '+(d.enabled?'enabled':'disabled');
  case 'notifications.admin_queued':return 'Notification queued — '+String(d.recipients||0)+' recipients';
  case 'notifications.enabled':return 'Notifications enabled on a device';
  case 'notifications.disabled':return 'Notifications disabled on a device';
  case 'notifications.preferences_changed':return 'Notification topics changed';
  case 'badge.accepted':return 'Accepted patch — '+String(d.name||'Patch');
  case 'badge.manually_awarded':return 'Patch awarded — '+String(d.name||d.badge_id||'Unavailable patch');
  case 'badge.definition_saved':return 'Patch updated — '+String(d.name||d.badge_id||'Unavailable patch');
  case 'badge.deleted':return 'Patch deleted — '+String(d.name||d.badge_id||'Unavailable patch');
  case 'badge.backfill':return 'Patch history applied — '+String(d.name||d.badge_id||'Unavailable patch');
  case 'gps.changed':return d.enabled?'GPS setting turned on':'GPS setting turned off';
  case 'sidebar.clicked':return 'Sidebar — '+String(d.label||'Destination');
  case 'place.opened':return 'Opened Place — '+String(d.place_name||'Place');
  default:return event.kind.replace(/[._]/g,' ');
 }
}
